<template>
	<v-card :elevation="1">
		<v-toolbar flat color="grey lighten-4 pt-1">
			<v-badge v-model="filtered" color="blue">
				<v-icon slot="badge" dark>filter_list</v-icon>
				<v-toolbar-title class="grey--text text--darken-4">{{ title }}</v-toolbar-title>
			</v-badge>                            
			<v-spacer></v-spacer>
			<v-text-field class="hidden-xs-only"
				append-icon="search"
				label="Cerca"
				v-model="search"
				clearable
			></v-text-field>

			<v-btn v-if="infoData.availableFilters" icon @click.native="showFilters = !showFilters">
				<v-tooltip bottom>
					<span slot="activator">
						<v-icon :color="filtered ? 'amber darken' : 'dark'">{{ filtered ? 'filter_list' : 'filter_list' }}</v-icon>
					</span>
					<span>
						Filtri avanzati
					</span>
				</v-tooltip>
			</v-btn>

			<v-menu offset-y v-if="infoData.menus" :min-width="150">
				<v-btn slot="activator" icon>
					<v-icon>more_vert</v-icon>
				</v-btn>
				<v-list>
					<v-list-tile v-for="(menu, index) in infoData.menus" :key="index" :to="menu.route">
						<v-list-tile-title>{{ menu.title }}</v-list-tile-title>
					</v-list-tile>
				</v-list>
			</v-menu>

		</v-toolbar>
		<v-divider></v-divider>

		<v-container fluid py-0>
			<v-layout row wrap>
				<v-flex xs12>
					<v-text-field class="hidden-sm-and-up"
						append-icon="search"
						label="Cerca"
						v-model="search"
						clearable
					></v-text-field>
				</v-flex>
			</v-layout>
		</v-container>

		<advanced-filters
			v-if="infoData.availableFilters"
			:infoAvailableFilters="infoData.availableFilters"
			:modelDef="infoData.modelDef"
			:filtered.sync="filtered"
			:show-filters.sync="showFilters"
			:get-cache="getCache"
		></advanced-filters>

		<v-data-table v-if="infoData.modelDef"
			:pagination.sync="pagination"
			:headers="fieldDefs"
			:items="items"
			:total-items="totalItems"
			:loading="loading"
			v-model="selected"
			:rows-per-page-items="[10, 25, 50,  { text: 'Tutti', value: -1 }]"
			select-all
			expand>

			<template slot="headers" slot-scope="props">
				<tr>
					<th style="width: 40px">
						<v-checkbox
							color="primary"
							@click.native="toggleAll"
							:input-value="props.all"
							:indeterminate="props.indeterminate"
							hide-details
						></v-checkbox>
					</th>
					<th v-for="header in props.headers" 
						:key="header.text"
						:style="header.width ? 'width:' + header.width + 'px' : ''"
						:class="['column sortable text-xs-'+(header.align?header.align:'left'), pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']"
						@click="changeSort(header)">
						<span>
							{{ header.text }}
						</span>
						<v-icon>arrow_upward</v-icon>
					</th>
				</tr>
			</template>

			<template slot="items" slot-scope="props">
				<tr class="cursor-pointer">
					<td>
						<v-checkbox
							color="blue"
							v-model="props.selected"
							hide-details
						></v-checkbox>
					</td>
					<template v-for="(header, h) in fieldDefs">
						<td v-if="header.text_value === 'fidelitycard_type_text'" :key="h"
							@click="openShow(props.item)">
							<div :class="$eventBusUtility.fidelitycardColor(props.item.type)">
								{{ props.item[header.text_value] }}
							</div>
						</td>
						<td v-else-if="header.type === 'currency'" :key="h">
							{{ props.item[header.value] | currency }}
						</td>
						<td v-else-if="typeof header.text_value !== 'undefined'" :key="h"
							@click="openShow(props.item)">
							{{ props.item[header.text_value] }}
						</td>
						<td v-else-if="header.value === 'actions'" :class="'text-xs-'+(header.align?header.align:'left')" style="width: 40px" :key="h">
							<template v-for="(action, a) in header.actions">
								<v-tooltip bottom :key="a">
									<v-btn v-if="action.url" slot="activator" icon class="mx-0" @click.stop="$eventBusUtility.goTo($router, action.url, props.item.id)" >
										<v-icon :color="action.color">{{ action.icon }}</v-icon>
									</v-btn>
									<v-btn v-else slot="activator" icon class="mx-0" @click="props.expanded = !props.expanded">
										<v-icon :color="action.color">{{ action.icon }}</v-icon>
									</v-btn>
									<span>
										{{ action.text }}
									</span>
								</v-tooltip>
							</template>
						</td>
						<td v-else :key="h"
							@click="openShow(props.item)">
							{{ props.item[header.value] }}
						</td>
					</template>
				</tr>
			</template>
			<template slot="expand" slot-scope="props">
				<v-card flat :key="props.index">
					<v-card-text pa-4 v-html="items[props.index].description"></v-card-text>
				</v-card>
			</template>
			<template slot="pageText" slot-scope="{ pageStart, pageStop }">
				<div class="blue--text"><span class="blue--text">{{ countSelected }}</span> Selezionati</div>
				Da {{ pageStart }} a {{ pageStop }} di {{ totalItems }}
			</template>

		</v-data-table>
		
		<v-card-text style="position: relative">
			<slot name="actions">
				<v-slide-y-reverse-transition>

				<v-speed-dial
					v-show="!showDial"
					v-model="fab"
					:fixed="actionPositionFixed"
					:absolute="actionPositionAbsolute"
					bottom
					:left="positionLeft"
					:right="positionRight"
					:direction="direction"
					transition="scale-transition">
					<v-btn
						slot="activator"
						color="blue"
						dark
						fab
						v-model="fab">
						<v-icon>{{ actionIcon }}</v-icon>
						<v-icon>close</v-icon>
					</v-btn>
					<v-tooltip top>
						<v-btn
							fab
							dark
							small
							color="indigo"
							slot="activator"
							@click.native.stop="openCreate">
							<v-icon>add</v-icon>
						</v-btn>
						<span>Nuovo</span>
					</v-tooltip>
					<v-tooltip top>
						<v-btn
							fab
							dark
							small
							color="red"
							slot="activator"
							:disabled="disabled"
							@click.native.stop="confirmDelete = true">
							<v-icon>delete</v-icon>
						</v-btn>
						<span>Elimina</span>
					</v-tooltip>
					<v-tooltip top>
						<v-btn
							fab
							dark
							small
							color="green"
							slot="activator"
							:disabled="disabled"
							@click.native.stop="$eventBusUtility.exportCSV(infoData.fieldDefs, selected, modelDef)">
							<v-icon>play_for_work</v-icon>
						</v-btn>
						<span>Esporta CSV</span>
					</v-tooltip>                            
					<v-tooltip top v-if="getSpeedDialOptions('sendMultipleMails')">
						<v-btn
							fab
							dark
							small
							color="blue lighten-1"
							slot="activator"
							:disabled="disabled"
							@click.native.stop="$router.push({name:'send-multiple-mails', params: { selected: selected }})">
							<v-icon>mail</v-icon>
						</v-btn>
						<span>Invia email multiple</span>
					</v-tooltip>
				</v-speed-dial>
			</v-slide-y-reverse-transition>
			</slot>
		</v-card-text>

        <v-dialog v-model="showDialog"
            max-width="800px"
            persistent lazy
            :fullscreen="$vuetify.breakpoint.xsOnly">
            <v-card>
                <v-toolbar flat color="grey lighten-4">
                    <v-toolbar-title class="pl-3 grey--text text--darken-4">
                        {{ title }}
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-divider></v-divider>
                <v-card-text class="pa-0">
                    <v-container fluid pa-2>
                        <fields-generator
                            :layoutClass="['row','wrap']" 
                            :fieldsset.sync="fieldsset"
                            :model="model"
                            ref="fieldsgenerator"
                            type="create"
                        ></fields-generator>
                        <small class="pl-4">* Indica i campi obbligatori</small>
                    </v-container>
                </v-card-text>
                <v-card-actions class="px-2">
                    <v-spacer></v-spacer>
                    <v-btn color="primary" flat @click.native.stop="closeDialog()">Chiudi</v-btn>
                    <v-btn color="primary" flat :loading="saved" @click.native="saveModel()">Salva</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>


		<confirm-dialog
			:confirmModel="confirmDelete"
			mainTitle="Eliminare gli elementi selezionati?"
			secondTitle="Gli elementi selezionati verranno eliminati solamente se indipendenti e non collegati a nessun altra entità. Una volta eliminati non sarà possibile ripristinarli"
			@update:confirmModel="confirmDelete = false"
			:atConfirm="deleteModels"
			:confirm="{label:'Procedi', color:'info'}"
		></confirm-dialog>

	
	</v-card>
</template>

<script>
import AdvancedFilters from '@/components/AdvancedFilters'
import DataTableMixin from '@/mixins/DataTableMixin.js'
import FieldsGenerator from '@/components/FieldsGenerator'

export default {
	name: 'crud',
	mixins: [DataTableMixin],
	components: {
		AdvancedFilters,
		FieldsGenerator
	},
	props: {
		title: String,
		actionIcon: String,
		modelDef: String,
		subFilters: Object,
		actionPosition: String,
		defaultInput: Object,
		redirect: Object,
		speedDialOptions: Object,
		positionRight: {
			type: Boolean,
			default: true
		},
		positionLeft: {
			type: Boolean,
			default: false
		},
		direction: {
			type: String,
			default: 'left'
		},
		crudDialog: {
			type: Boolean,
			default: false
		},
	},

	data() {
		return {
			confirmDelete: false,
			disabled: true,
			fab: false,
			infoData: {},
			selected: [],
			search: '',
			totalItems: 0,
			items: [],
			loading: false,
			pagination: {},
			filtered: false,
			debounceUnwatch: {},
			advancedFilters: {},
			showFilters: false,
			showDial: true,
			// dialog datas
			showDialog: false,
			model: {},
			fieldsset: false,
			saved: false,
		}
	},

	watch: {
		pagination: {
			handler: function(newValue, oldValue) {
				if(! _.isEmpty(oldValue) ){
					if(_.isEmpty(this.subFilters))
						localStorage.setItem('crud_pagination_'+this.modelDef, JSON.stringify(newValue))
				}
				this.getDataFromApi()
			},
			deep: true,
		},


		search: {
			handler() {
				if (_.isEmpty(this.subFilters)) {
					if (this.search == null) {
						localStorage.removeItem('crud_search_' + this.modelDef)
					} else {
						localStorage.setItem('crud_search_' + this.modelDef, this.search)
					}
				}
			}
		},
	},

	computed: {
		getCache() {
			return _.isEmpty(this.subFilters)
		},
	},

	methods: {

		generateDefaultInput(item, defaultInput) {
			let params = {}
			if(defaultInput) {
				_.forEach(defaultInput, (value, key) => {
					params[key] = item[value]
				})
			}
			return params
		},

		getDataFromApi() {
			this.loading = 'primary'

			let dataObject = {
				page: this.pagination.page,
				per_page: this.pagination.rowsPerPage,
				sort: this.pagination.sortBy + '|' + (this.pagination.descending ? 'DESC' : 'ASC'),
				advancedFilters: this.advancedFilters,
				filter: this.search,
				subFilters: this.subFilters
			}

			let url = this.infoData.modelDef + '-filters'

			this.axios.post(url, dataObject).then(response => {
				this.loading = false
				this.items = response.data.data.data
				this.totalItems = response.data.data.total

				// this.pagination.totalItems = data.total
			},
			response => {
				// error callback
				this.loading = false
			})
		},

		openShow(item) {
			if(this.crudDialog) {
			// open show in dialog (edit)
				this.axios.get(this.modelDef + '/' + item.id + '/edit').then(response => {

					this.fieldsset = response.data.fields
					this.model = response.data.model
					this.showDialog = true
					this.type = 'create'
					//this.$refs.customfielddialog.show = true

				}, response => {
					// error callback
				})
			} else {
				// open in other view
				this.$router.push({ name: this.modelDef, params: { id: parseInt(item.id), redirect: this.redirect }})
			}
		},


		openCreate() {
			if(this.crudDialog) {
				// open create in dialog
				this.axios.get(this.modelDef + '/create').then(response => {

					this.fieldsset = response.data.fields
					this.model = this.defaultInput
					this.showDialog = true
					this.type = 'create'
					//this.$refs.customfielddialog.show = true

				}, response => {
					// error callback
				})
			} else {
				// open in other view
				this.$router.push({ name: this.modelDef+'-create', params: {defaultInput: this.defaultInput, redirect: this.redirect}})
			}
		},

		closeDialog() {
			this.showDialog = false
			this.model = {}
			this.saved = false
		},


		saveModel() {
			// only for dialog
			this.$refs.fieldsgenerator.$validator.validateAll().then(result => {
				if (!result) {
					return false
				}

				this.saved = true
				
				if(_.has(this.model, 'id')) { // edit
					this.axios.put(this.modelDef + '/' + this.model.id, this.model).then(response => {
						// get body data
						this.getDataFromApi()
						this.closeDialog()
					}, response => {
						// error callback
					})
				} else { // create

					this.axios.post(this.modelDef, this.model).then(response => {
						// get body data
						this.getDataFromApi()
						this.closeDialog()
					}, response => {
						// error callback
					})
				}
			}).catch(() => {

			})
		},

	},

	created() {
		if (_.isEmpty(this.subFilters) && localStorage.getItem('crud_search_' + this.modelDef) !== null) {
			this.search = localStorage.getItem('crud_search_' + this.modelDef)
		}

		// Get info data for model
		this.axios.get(this.modelDef + '-info').then(response => {
			// get info data
			this.infoData = response.data.info

			if(_.isEmpty(this.subFilters) && localStorage.getItem('crud_pagination_'+this.modelDef) !== null){
				let pag_temp = JSON.parse(localStorage.getItem('crud_pagination_'+this.modelDef))
				if(pag_temp.rowsPerPage == -1){
					delete pag_temp.rowsPerPage
				}
				Object.assign(this.pagination, pag_temp)
			}
			else if(response.data.info.pagination) {
				Object.assign(this.pagination, response.data.info.pagination)
			}

			this.$store.commit('endProgress')
			setTimeout(() => { this.showDial = false }, this.$store.getters.dialTimeout)


		}, response => {
			// error callback
			this.loading = false
		})


		this.debounceUnwatch = this.$watch('search', _.debounce(this.getDataFromApi, 700))
	},

	mounted() {
		this.$eventBusUtility.$on('refreshTable', modelDef => {
			this.getDataFromApi()
		})

		this.$eventBusUtility.$on('filters_' + this.modelDef, advancedFilters => {
			this.advancedFilters = advancedFilters
			localStorage.setItem('crud_advancedFilters_' + this.modelDef, JSON.stringify(this.advancedFilters))
			this.getDataFromApi()
		})
	}
}
</script>
<style scoped>
.priority {
  border-radius: 3px;
  padding: 4px;
  font-weight: 500 !important;
  color: white;
  max-width: 95px;
  text-align: center;
}
</style>
